'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import { BsPlayCircle } from 'react-icons/bs';
import { MdOutlineClose } from 'react-icons/md';
import { Modal } from '@/src/components/Modal';
import i18n from '@/src/i18n';
import { sendAnalyticsData } from '@/src/utils/analytics';
interface ITutorialItem {
  videoUrl: string;
  bgColor: string;
  bgImage: string;
  title: string;
}
interface IProps {
  data: ITutorialItem;
  index: number;
  clickedIndex: number;
  videoHandler: (index: number) => void;
}
export const TutorialItem = t0 => {
  const $ = _c(29);
  const {
    data,
    index,
    clickedIndex,
    videoHandler
  } = t0;
  const {
    bgColor,
    bgImage,
    title,
    videoUrl
  } = data;
  const [isModalOpen, setModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setModalOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeModal = t1;
  const t2 = `aspect-video w-full cursor-pointer overflow-hidden rounded-t-xl ${bgColor}`;
  let t3;
  if ($[1] !== index || $[2] !== title || $[3] !== videoHandler) {
    t3 = () => {
      videoHandler(index);
      setModalOpen(true);
      sendAnalyticsData("TUTORIAL_VIDEO_CLICKED", {
        title
      });
    };
    $[1] = index;
    $[2] = title;
    $[3] = videoHandler;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = ` relative h-full w-full bg-cover bg-bottom bg-no-repeat lg:bg-contain xl:bg-cover ${bgImage}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = i18n.t("Tutorial");
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== bgImage) {
    t6 = <Image className="absolute" src={bgImage} alt={t5} width={500} height={500} />;
    $[6] = bgImage;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute flex h-full w-full items-center justify-center"><BsPlayCircle className="h-20 w-20 text-white hover:text-[#FFFFFFCC]" /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6) {
    t8 = <div className="h-full w-full"><div className={t4}>{t6}{t7}</div></div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t8) {
    t9 = <div className={t2} onClick={t3}>{t8}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== title) {
    t10 = <div className="flex flex-col gap-y-1 rounded-b-xl bg-[#FCFCFC] p-4"><div className="text-[16px] font-normal text-[#3D3E40]">{title}</div></div>;
    $[16] = title;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="flex flex-col ">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== clickedIndex || $[22] !== index || $[23] !== isModalOpen || $[24] !== videoUrl) {
    t12 = index === clickedIndex ? <div className="container self-center"><Modal isOpen={isModalOpen} closeModal={closeModal} className="container relative md:h-[540px] md:w-[720px] lg:w-[960px]" component={<div className="md:h-[540px] md:w-[720px] lg:w-[960px] "><div className="flex w-full justify-end p-2"><MdOutlineClose className="h-6 w-6  text-[#3D3E40] " onClick={closeModal} /></div><iframe height="100%" width="100%" className="aspect-video rounded-xl" src={`https://www.youtube.com/embed/${videoUrl}?autoplay=1&enablejsapi=1`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} /></div>} /></div> : <></>;
    $[21] = clickedIndex;
    $[22] = index;
    $[23] = isModalOpen;
    $[24] = videoUrl;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};